<template>
<div class="a7-login">
  <gw-card class="login-card">
    <h1 slot="header" class="welcome">Seja bem-vindo!</h1>
    <div slot="body" class="form">
      <form @submit.prevent="efetuarLogin">
        <div class="form-group">
          <label class="sr-only" for="userInput">Usuário</label>
          <input v-model="login" type="text" class="form-control input-lg" id="userInput" placeholder="Usuário">
        </div>
        <div class="form-group">
          <label class="sr-only" for="passwordInput">Senha</label>
          <input v-model="senha" type="password" class="form-control input-lg" id="passwordInput" placeholder="Senha">
        </div>
        <button type="submit" class="btn btn-primary btn-block btn-lg login-button">Login</button>
      </form>
    </div>
  </gw-card>
</div>
</template>

<script>
import {
  GwCard
} from 'guaxinim-web'

import TokenStorage from '@/js/TokenStorage'
import SessaoRestResource from '@/components/sessao/SessaoRestResource'
import md5 from 'md5'

export default {
  name: "a7-login",
  components: {
    GwCard
  },
  data: () => ({
    login: null,
    senha: null
  }),
  methods: {
    efetuarLogin() {

      const credencial = {
        login: !this.login ? null : this.login,
        senha: !this.senha ? null : md5(this.senha)
      }

      SessaoRestResource.login(credencial).then((response) => {
        TokenStorage.storeAuthToken(response.token)

        const redirectFrom = this.$route.query.redirectFrom
        if (redirectFrom) {
          this.$router.push({ path: redirectFrom })
        }
        else {
          this.$router.push({ path: '/' })
        }
      }).catch((err) => this.$gw.defaultExceptionHandler.handleUnknownException(err, this));
    }
  }
}
</script>

<style lang="scss" scoped>
.a7-login {
    background-color: #eee;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.login-card {
    margin-left: auto;
    margin-right: auto;
    width: 350px;

    .welcome {
        text-align: center;
        margin-top: 20px;
    }

    .form {
        margin: 20px 50px 50px;
    }

    .login-button {
        margin-top: 30px;
    }
}
</style>
